// extracted by mini-css-extract-plugin
export default {"brands":"Brands_brands__ZFXRb","brandsList":"Brands_brandsList__n8h-3"};